export default __webpack_public_path__ + "static/media/Screen Shot 2020-06-15 at 3.02.52 PM copy.eb6850c2.png";